import useRepeatableMetaData from '@v4/hooks/useRepeatableMetaData'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import useStyles from './Item.styled'

export const useItem = props => {
	const { group, itemKey, index } = props
	const metaData = useRepeatableMetaData({ group, index })
	const classes = useStyles(props)

	const { handleFocus: handleClick } = useFieldFocus({ metaData: { config: { group } }, index, itemKey })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.itemImage, index, itemKey })
	const { handleFocus: handleDescriptionClick } = useFieldFocus({
		metaData: metaData.itemDescription,
		index,
		itemKey,
	})

	const { editable: descriptionEditable, handleChange: handleDescriptionChange } = useEditorMeta({
		metaData: metaData.itemDescription,
		key: 'itemDescription',
		index,
	})

	return [
		{
			classes,
			image: metaData.itemImage,
			withImage: !!metaData.itemImage?.image,
			itemDescription: metaData.itemDescription?.metaValue,
			itemDescriptionConfig: metaData.itemDescription?.config,
			itemKey,
			group,
			descriptionEditable,
			descriptionKey: metaData.itemDescription?.tierKey,
		},
		{ handleImageClick, handleDescriptionClick, handleClick, handleDescriptionChange },
	]
}
